import React, { PropsWithChildren } from 'react';

import { css, ThemeProvider, Global } from '@emotion/react';

import { theme } from '@britishcouncil/react-extro-ui/dist/theme/theme';
import { reset } from '@britishcouncil/react-extro-ui/dist/theme/styles/reset';
import { ExtroProvider } from '@britishcouncil/react-extro-ui';

export const ScopedExtroProvider = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <ExtroProvider>
      <ThemeProvider theme={theme}>
        <Global
          styles={css`
            ${reset}
          `}
        />
        {children}
      </ThemeProvider>
    </ExtroProvider>
  );
};
